import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || '/api';

const getAuthHeaders = () => {
    const token = localStorage.getItem('token');
    return {
        headers: { Authorization: `Bearer ${token}` }
    };
};

export const clientesImportacionService = {
    getClientes: async () => {
        try {
            const response = await axios.get(`${API_URL}/clientes-importacion/clientes`, getAuthHeaders());
            return response.data;
        } catch (error) {
            console.error('Error fetching clientes:', error);
            throw error;
        }
    },

    importarExcel: async (file) => {
        try {
            const formData = new FormData();
            formData.append('excel', file);

            const headers = getAuthHeaders();
            headers.headers['Content-Type'] = 'multipart/form-data';

            const response = await axios.post(`${API_URL}/clientes-importacion/importar`, formData, headers);
            return response.data;
        } catch (error) {
            console.error('Error importing excel:', error);
            throw error;
        }
    },

    descargarPlantilla: async () => {
        try {
            const response = await axios.get(`${API_URL}/clientes-importacion/plantilla`, {
                ...getAuthHeaders(),
                responseType: 'blob'
            });
            return response.data;
        } catch (error) {
            console.error('Error downloading template:', error);
            throw error;
        }
    }
};
